import { api, unwrap } from '@/data/api/client';
import type { NewsItem } from '@/domain/types';

export const newsRepo = {
  latest: () => unwrap<NewsItem[]>(api.GET('/news', {})),
};
